








































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ProjectModule, Project } from '@/store/projects';
import { ApiHelper } from '@/ApiHelper';
import Projects from '@/components/Projects.vue';
import { AppModule } from '@/store/app';

@Component <ProjectsView> ({
  components: {
    Projects
  },
  head: {
    title() { 
      return { inner: this.documentTitle }
    },
    meta() {
      return [
        { property: 'og:title', content: this.documentTitle, id:'ogtitle' },
        { property: 'og:type', content: 'website', id: 'ogtype' },
        { property: 'og:description', content: 'なわてん - 2020年度 大阪電気通信大学 四條畷キャンパス 卒業研究・卒業制作展 総合情報学部、デジタルゲーム学科、情報学科、医療健康科学部 2021年2月13日（土）、14日（日）11時〜17時【オンライン開催】', id: 'ogdescription'},
        { property: 'og:url', content: document.URL, id: 'ogurl' },
        { property: 'og:image', content: document.URL + 'img/ogp.png', id:'ogimage' },
        { property: 'twitter:card', content: 'summary_large_image', id:'twittercard' },
        { property: 'twitter:site', content: '@nawaten_info', id: 'twittersite' },
      ];
    },
  },
})

// wordpress rest api
// テーマ別
//dev.nawaten.online/wp-json/wp/v2/project/?project_theme=5
// 研究室別
//dev.nawaten.online/wp-json/wp/v2/project/?lab=5
// 学科別
//dev.nawaten.online/wp-json/wp/v2/project/?department=5
// キーワード検索
//dev.nawaten.online/wp-json/wp/v2/project?search=概要


export default class ProjectsView extends Vue {
  private total = 0;
  private totalpages = 0;
  private currentpage = 1;
  private routename = '';
  private eyecatch = '';
  private title = '';
  private documentTitle = '';

  private created() {
    AppModule.setLoaded(true);
  }
  private mounted(){
    this.handlePage();
  }

  public handlePage() {

    // タクソノミー情報
    this.routename = this.$route.name ? this.$route.name : "Department"; // 例外について後で考える
    let taxonomy = this.$route.name ? this.$route.name.toLowerCase() : "department";
    if(taxonomy == 'projecttheme') taxonomy = 'project_theme';
    ApiHelper.callApi(`wp-json/wp/v2/${taxonomy}/`+this.$route.params[taxonomy], 'get', {}, res => {
      this.title = res.data.name;
      this.documentTitle = res.data.name + ' | ' + res.data["blog_title"];
      this.$emit('updateHead');
    });

    this.currentpage = this.$route.params.page ? Number(this.$route.params.page) : 1;
    let path = `wp-json/wp/v2/project?per_page=12&page=${this.currentpage}&_embed`;
    if(this.$route.params.lab) path = `${path}&lab=${this.$route.params.lab}`;
    if(this.$route.params.department) path = `${path}&department=${this.$route.params.department}`;
    if(this.$route.params.project_theme) path = `${path}&project_theme=${this.$route.params.project_theme}`;
    ApiHelper.callApi(path, 'get', {}, res => {
      ProjectModule.setProjects(res.data.map((v: any)=>{
        return {
          id: v.id,
          title: v.title.rendered as string,
          eyecatch: v.featured_image_url as string,
          terms: v._embedded['wp:term'] ? v._embedded['wp:term'].flat() : [],
          squareEyecatch: v.acf.squareEyecatch as string,
        } as Project;
      }));
      this.total = parseInt(res.headers["x-wp-total"]);
      this.totalpages = parseInt(res.headers["x-wp-totalpages"]);

    });
  }
}
